module.exports = "/_next/static/images/92be3d0c1ce24db8c2b9cdf5c1d6805a-payment_boleto.png.webp";